module.exports = __webpack_public_path__ + "static/media/welcome-page-image.ecc68804.png";